import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class SgHotjarService {
  private loaded = false;

  constructor(private env: EnvironmentService) {}

  loadHotjar(): void {
    const hjid = this.env.hotjar[`trackingCode_${this.env.appNameWithoutPrefix}`];
    if (this.loaded || !hjid) {
      return;
    }
    this.loaded = true;

    Object.defineProperty(window, 'hj', {
      value:
        (window as any).hj ||
        function () {
          ((window as any).hj.q = (window as any).hj.q || []).push(arguments);
        },
      configurable: true,
      writable: true,
    });

    Object.defineProperty(window, '_hjSettings', {
      value: { hjid, hjsv: 6 },
      configurable: true,
      writable: true,
    });
    const head = document.querySelector('head'),
      script = document.createElement('script'),
      uri = `https://static.hotjar.com/c/hotjar-${(window as any)._hjSettings.hjid}.js?sv=${
        (window as any)._hjSettings.hjsv
      }`;

    script.async = true;
    script.src = uri;
    head.appendChild(script);
  }
}
